import { render } from "./editDeckDocument.vue?vue&type=template&id=dedbadb2&scoped=true"
import script from "./editDeckDocument.vue?vue&type=script&lang=js"
export * from "./editDeckDocument.vue?vue&type=script&lang=js"

import "./editDeckDocument.vue?vue&type=style&index=0&id=dedbadb2&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedbadb2"]])

export default __exports__